import React from "react";
import { Cell, Legend, Pie, PieChart } from "recharts";

const PieChat = ({ data, colors, width, height }) => {
  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };
  return (
    <PieChart width={width ? width : 450} height={height ? height : 460}>
      <Pie
        data={data}
        cx={width ? width / 2 : 200}
        cy={height ? height / 2 : 200}
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={width ? width / 2 - 10 : 200}
        fill="#8884d8"
        dataKey="count"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
        ))}
      </Pie>
      <Legend verticalAlign="bottom" />
    </PieChart>
  );
};

export default PieChat;
